import React, { useState, useEffect } from 'react';
import './index.css';
import { api } from '../../services/api';

import Menu from '../../comum/Menu';
import Footer from '../../comum/Footer';
import BarcodeModal from './../Components/BarcodeScanner'; // NOVO COMPONENTE

function PrecoProduto() {
  const [ean, setEan] = useState('');
  const [produtos, setProdutos] = useState([]);
  const [descricao, setDescricao] = useState('');
  const [pesquisa, setPesquisa] = useState('');
  const [showScanner, setShowScanner] = useState(false);
  const [imagemUrl, setImagemUrl] = useState('');

  useEffect(() => {
    if (!pesquisa) return;

    const fetchProduto = async () => {
      try {
        const response = await api.get('/PROD/' + pesquisa);
        const data = response.data;

        if (data && data.length > 0) {
          setProdutos(data);
          setDescricao(data[0].descricao);
        } else {
          setProdutos([]);
          setDescricao("Produto não encontrado.");
        }
      } catch (err) {
        console.error("Erro na API:", err);
        setProdutos([]);
        setDescricao("Erro ao buscar produto.");
      }
    };

    fetchProduto();
  }, [pesquisa]);

  useEffect(() => {
    if (!pesquisa) return;

    const verificarImagem = async () => {
      const url = `https://cdn-cosmos.bluesoft.com.br/products/${pesquisa}`;//`http://www.eanpictures.com.br:9000/api/gtin/${pesquisa}`;
      console.log(url);
      try {
        const response = await fetch(url, { method: 'HEAD' });
        if (response.ok) {
          setImagemUrl(url);
        } else {
          setImagemUrl('https://multilit.com.br/wp-content/uploads/2020/03/Produto-sem-foto.png');
        }
      } catch (error) {
        console.error("Erro ao buscar imagem:", error);
        setImagemUrl('https://multilit.com.br/wp-content/uploads/2020/03/Produto-sem-foto.png');
      }
    };
    verificarImagem();
  }, [pesquisa]);

  const handleScan = (codigo) => {
    if (!codigo || codigo.length < 8) {
      console.warn("Código inválido:", codigo);
      return;
    }
    setEan(codigo);
    setPesquisa(codigo);
    setShowScanner(false);
  };

  return (
    <div>
      <Menu modulo="" />
      <div className="container-fluid pagina-dados">
        <div className="offset-lg-3 col-lg-6">
          <form>
            <div className="row">
              <div className="col-xl-4 col-lg-4 col-12">
                <label className="form-label">Código de barra</label>
                <div className="input-group">
                  <input
                    value={ean}
                    onChange={(e) => setEan(e.target.value)}
                    maxLength={13}
                    type="number"
                    className="form-control"
                    placeholder="Digite ou escaneie"
                  />
                  <button
                    className="btn btn-secondary"
                    type="button"
                    onClick={() => setShowScanner(true)}
                  >
                    <i className="fas fa-camera"></i>
                  </button>
                </div>
                <button
                  onClick={() => setPesquisa(ean)}
                  className="btn btn-outline-danger mt-2"
                  type="button"
                >
                  <i className="fas fa-search"></i> Pesquisar
                </button>
              </div>
            </div>

            <div className="mb-3 mt-3">
              <label className="form-label">Descrição</label>
              <input
                value={descricao}
                type="text"
                className="form-control"
                disabled
              />
            </div>

            {pesquisa && (
              <div className="text-center mb-3">
                <img
                  src={`https://cdn-cosmos.bluesoft.com.br/products/${pesquisa}`}
                  
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'https://multilit.com.br/wp-content/uploads/2020/03/Produto-sem-foto.png';
                  }}
                  alt="Foto do produto"
                  className="img-thumbnail"
                  style={{ maxHeight: '200px', objectFit: 'contain' }}
                />
              </div>
            )}

            <div className="mb-3">
              <label className="form-label">Preços nas lojas</label>
              <table className="table table-hover table-bordered">
                <thead>
                  <tr align="center" className="table-secondary">
                    <th>Loja</th>
                    <th>Valor</th>
                    <th>Tipo</th>
                  </tr>
                </thead>
                <tbody>
                  {produtos.map((p) => (
                    <tr key={p.loja}>
                      <td>{p.loja}</td>
                      <td align="right" className="preco">{p.preco}</td>
                      <td align="center" className="detalhe">{p.promo}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </form>
        </div>

        {/* Scanner em Modal */}
        <BarcodeModal
          show={showScanner}
          onClose={() => setShowScanner(false)}
          onScanSuccess={handleScan}
        />

        <Footer className="footer navbar-fixed-bottom" />
      </div>
    </div>
  );
}

export default PrecoProduto;
